import React from "react";
import "./pspComponentsCommon.scss";

const BorderLine = () => <div className="border-line" />;

export default BorderLine;
